import React, { useLayoutEffect, useState } from "react";

import { createPortal } from "react-dom";

const createWrapperAndAppendToBody = (wrapperId, portalPlacement, locked) => {
  if (document.getElementById(wrapperId))
    return document.getElementById(wrapperId);
  else {
    const wrapperElement = document.createElement("div");
    wrapperElement.setAttribute("id", wrapperId);
    if (locked) {
      wrapperElement.setAttribute("class", "portal-body");
    }

    wrapperElement.setAttribute("style", "height: 100%");

    if (portalPlacement === "body") {
      document.body.appendChild(wrapperElement);
    } else {
      if (portalPlacement) {
        const containerElement = document.querySelector(portalPlacement);
        if (containerElement) containerElement.appendChild(wrapperElement);
      }
    }
    return wrapperElement;
  }
};

const Portal = ({
  children,
  wrapperId = "react-portal-wrapper",
  locked = true,
  portalEmpty = false,
  portalPlacement = "body",
}) => {
  const [wrapperElement, setWrapperElement] = useState();
  useLayoutEffect(() => {
    setWrapperElement(
      createWrapperAndAppendToBody(wrapperId, portalPlacement, locked)
    );

    return () => {
      if (portalEmpty) return;
      createWrapperAndAppendToBody(
        wrapperId,
        portalPlacement,
        locked
      )?.remove();
    };
  }, [wrapperId, portalPlacement, portalEmpty]);

  React.useEffect(() => {
    if (locked) {
      const html = document.getElementsByTagName("html")[0];
      html.classList.add("lock-scroll");

      return () => {
        if (!document.querySelectorAll(".portal-body").length)
          html.classList.remove("lock-scroll");
        //   html.classList.add("lock-scroll");
        // } else {
        //   html.classList.remove("lock-scroll");
        // }
      };
    } else {
      return () => {};
    }
  }, [locked]);
  return wrapperElement ? createPortal(children, wrapperElement) : null;
};

export default Portal;
